import api from '@/services/api'

import Auth from '../auth'
import { apiErrorHandler } from '../utils/apiErrors'

const GOALS_ENDPOINT = 'goals/'

export default class GoalAPI {
  /**
   * Instantiate a new `GoalAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `GoalAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new GoalAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  async create(project) {
    const url = GOALS_ENDPOINT
    const data = this.cls.toAPI(project)

    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Create goal API error' }))
  }

  get(goalId) {
    const url = `${GOALS_ENDPOINT}${goalId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  async update(goal, fields = []) {
    this.cls.checkIsInstance(goal, 'The `goal` argument')

    const url = `${GOALS_ENDPOINT}${goal.id}/`
    const data = this.cls.toAPI(goal, fields)

    const promise = this.client.patch(url, data)
    return promise
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Update goal API error' }))
  }

  list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const url = GOALS_ENDPOINT
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }
    if (filters.project) {
      options.params.project = filters.project
    }
    if (filters.future) {
      options.params.future = filters.future
    }
    if (filters.maker) {
      options.params.maker = filters.maker
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => ({
        ...data,
        results: data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'Goal API error' }))
  }

  /**
   * Make payment toward a goal.
   *
   * @param {int} amount - Amount to pay, in cents.
   */
  makePayment(goalId, amount) {
    const url = `${GOALS_ENDPOINT}${goalId}/make-payment/`
    const authHeader = Auth.getAuthorizationHeader()
    const data = {
      amount,
    }

    const options = {
      headers: {
        ...authHeader,
      },
    }
    return this.client
      .post(url, data, options)
      .then(response => response.data)
      .catch(apiErrorHandler({ apiName: 'API error' }))
  }
  // Collect Funds
  collectFunds(goal) {
    const url = `${GOALS_ENDPOINT}${goal.id}/collect-funds/`
    const authHeader = Auth.getAuthorizationHeader()
    const data = {}

    const options = {
      headers: {
        ...authHeader,
      },
    }
    return this.client
      .post(url, data, options)
      .then(response => response.data)
      .catch(apiErrorHandler({ apiName: 'API error' }))
  }
}
